import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const initialPublicUser = {
  UserName: "",
  LastName: "",
  FirstName: "",
  Email: "",
  StateID: 0,
  City: "",
  PhoneNumber: "",
  FromDate: "",
  ToDate: "",
  ConnectionStatus: "2",
  ActiveStatus: "4",
  PageNo: 1,
  RowCountPerPage: 10,
  sortBy: "",
};

const name = "registeredUser";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const registeredUserActions = { ...slice.actions, ...extraActions };
export const registeredUserReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    RegisteredPublicUserList: [],
    RegisteredUsersFullList: [],
    publicUserInformation: [],
    publicUserNotes: [],
    updateStatusResponse: null,
    updateNotesResponse: null,
    loadConnectionList: [],
    loadConnectionFullList: [],
    validateresendEmailVerification: [],
    resendActivationEmail: [],
    loginhistory: [],
    allLoginhistory: [],
    fullLoginHistory: [],
    statusHistory: {},
    statusExcelHistory: [],
    activateAccountManully: [],
    registeredUser: initialPublicUser,
    initialPublicUser: initialPublicUser,
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    setRegisteredUser,
    resetForm,
    clearRegisteredPublicUserList,
    clearpublicUserInformation,
    clearvalidateresendEmailVerification,
    clearresendActivationEmail,
    clearActivateUserRes,
    clearupdateStatusResponse,
    clearupdateNotesresponse,
    clearpublicUserNotes,
    clearexcelData,
    clearConnectionExcel,
    clearLoginInfoExcel,
    clearSettingExcelHistory,
  };

  function resetForm(state) {
    // Resetting the form fields to their default values
    state.registeredUser = { ...initialPublicUser };
  }
  function setRegisteredUser(state, action) {
    state.registeredUser = action && action.payload;
  }
  function clearRegisteredPublicUserList(state) {
    state.RegisteredPublicUserList = [];
  }
  function clearpublicUserInformation(state) {
    state.publicUserInformation = [];
  }
  function clearvalidateresendEmailVerification(state) {
    state.validateresendEmailVerification = [];
  }
  function clearresendActivationEmail(state) {
    state.resendActivationEmail = [];
  }
  function clearActivateUserRes(state) {
    state.activateAccountManully = [];
  }
  function clearupdateStatusResponse(state) {
    state.updateStatusResponse = [];
  }
  function clearupdateNotesresponse(state) {
    state.updateNotesResponse = [];
  }
  function clearpublicUserNotes(state) {
    state.publicUserNotes = [];
  }
  function clearexcelData(state) {
    state.RegisteredUsersFullList = [];
  }
  function clearConnectionExcel(state) {
    state.loadConnectionFullList = [];
  }
  function clearLoginInfoExcel(state) {
    state.fullLoginHistory = [];
  }
  function clearSettingExcelHistory(state) {
    state.statusExcelHistory = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/PublicUser`;

  return {
    LoadRegisteredPublicUserList: LoadRegisteredPublicUserList(),
    GetPublicUserInfo: GetPublicUserInfo(),
    GetPublicUserNotes: GetPublicUserNotes(),
    LoadAccountStatusHistory: LoadAccountStatusHistory(),
    UpdateStatus: UpdateStatus(),
    LoadLoginHistory: LoadLoginHistory(),
    LoadConnectionList: LoadConnectionList(),
    UpdateNotes: UpdateNotes(),
    ValidateResendActivationEligibility: ValidateResendActivationEligibility(),
    ResendActivationEmail: ResendActivationEmail(),
    ActivateAccountManually: ActivateAccountManually(),
  };

  function LoadRegisteredPublicUserList() {
    return createAsyncThunk(
      `${name}/LoadRegisteredUserList`,
      async (inputparams, thunkAPI) => {
        try {
          if (inputparams.IsDownloadExcel) {
            const blob = await fetchWrapper.post(
              `${baseUrl}/LoadRegisteredUserList`,
              inputparams,
              { isFile: true }
            );
            const fileName = `RegisteredPublicUsers_List.xlsx`;
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
  
            return thunkAPI.fulfillWithValue(null);
          } else {
            return await fetchWrapper.post(
              `${baseUrl}/LoadRegisteredUserList`,
              inputparams
            );
          }
        } catch (error) {
          console.error("Error:", error);
          return thunkAPI.rejectWithValue(error.message || "Unexpected error");
        }
      }
    );
  }
  
  
  function GetPublicUserInfo() {
    return createAsyncThunk(`${name}/GetUserInfo`, async (PublicUserID) => {
      return await fetchWrapper.get(
        `${baseUrl}/GetUserInfo?PublicUserID=${PublicUserID}`
      );
    });
  }

  function GetPublicUserNotes() {
    return createAsyncThunk(
      `${name}/GetNotes`,
      async ({ publicUserID, facilityID }) => {
        return await fetchWrapper.get(
          `${baseUrl}/GetNotes?PublicUserID=${publicUserID}&facilityID=${facilityID}`
        );
      }
    );
  }
  function LoadAccountStatusHistory() {
    return createAsyncThunk(
      `${name}/LoadAccountStatusHistory`,
      async ({ PublicUserID, PageNo, RowCountPerPage, SortField }) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadAccountStatusHistory?PublicUserID=${PublicUserID}&PageNo=${PageNo}&RowCountPerPage=${RowCountPerPage}&SortField=${SortField}`
        );
      }
    );
  }
  function UpdateStatus() {
    return createAsyncThunk(`${name}/UpdateStatus`, async (updateStatus) => {
      return await fetchWrapper.post(`${baseUrl}/UpdateStatus`, updateStatus);
    });
  }
  function UpdateNotes() {
    return createAsyncThunk(`${name}/UpdateNotes`, async (UpdateNotes) => {
      return await fetchWrapper.post(`${baseUrl}/UpdateNotes`, UpdateNotes);
    });
  }

  function LoadConnectionList() {
    return createAsyncThunk(
      `${name}/LoadConnectionList`,
      async (connection) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadConnectionList`,
          connection
        );
      }
    );
  }

  function LoadLoginHistory() {
    return createAsyncThunk(
      `${name}/LoadLoginHistory`,
      async (loginhistory) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadLoginHistory`,
          loginhistory
        );
      }
    );
  }
  function ValidateResendActivationEligibility() {
    return createAsyncThunk(
      `${name}/ValidateResendActivationEligibility`,
      async (email) => {
        return await fetchWrapper.get(
          `${baseUrl}/ValidateResendActivationEligibility?Email=${email}`
        );
      }
    );
  }
  function ResendActivationEmail() {
    return createAsyncThunk(`${name}/ResendActivationEmail`, async (email) => {
      return await fetchWrapper.post(`${baseUrl}/ResendActivationEmail`, email);
    });
  }
  function ActivateAccountManually() {
    return createAsyncThunk(
      `${name}/ActivateAccountManually`,
      async (param) => {
        return await fetchWrapper.post(
          `${baseUrl}/ActivateAccountManually`,
          param
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    //Registered User Grid Load
    .addCase(extraActions.LoadRegisteredPublicUserList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadRegisteredPublicUserList.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.RegisteredUsersFullList = action.payload;
        } else {
          state.RegisteredPublicUserList = action.payload;
        }
        state.loading = false;
      }
    )
    .addCase(
      extraActions.LoadRegisteredPublicUserList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // Fetching a single public user's information by ID
    .addCase(extraActions.GetPublicUserInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPublicUserInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.publicUserInformation = action.payload;
    })
    .addCase(extraActions.GetPublicUserInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Fetch the PublicUser Notes -  Setting Tab
    .addCase(extraActions.GetPublicUserNotes.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(extraActions.GetPublicUserNotes.fulfilled, (state, action) => {
      state.loading = false;
      state.publicUserNotes = action.payload;
    })
    .addCase(extraActions.GetPublicUserNotes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    // Fetches account status history data to load into the grid in the Settings tab
    .addCase(extraActions.LoadAccountStatusHistory.pending, (state) => {
      state.statusHistory.loading = true;
      state.error = false;
    })
    .addCase(
      extraActions.LoadAccountStatusHistory.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.statusExcelHistory = action.payload;
        } else {
          state.statusHistory = action.payload;
        }

        state.statusHistory.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadAccountStatusHistory.rejected,
      (state, action) => {
        state.statusHistory.loading = false;
        state.error = action.error;
      }
    )
    // Handles updating the status and notes in the Settings Tab
    .addCase(extraActions.UpdateStatus.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(extraActions.UpdateStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.updateStatusResponse = action.payload;
    })
    .addCase(extraActions.UpdateStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Handles updating the Notes in the Settings Tab
    .addCase(extraActions.UpdateNotes.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(extraActions.UpdateNotes.fulfilled, (state, action) => {
      state.loading = false;
      state.updateNotesResponse = action.payload;
    })
    .addCase(extraActions.UpdateNotes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //Fetches Connection data to load into the grid in the Connection tab
    .addCase(extraActions.LoadConnectionList.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(extraActions.LoadConnectionList.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.loadConnectionFullList = action.payload;
      } else {
        state.loadConnectionList = action.payload;
      }
      state.loading = false;
    })
    .addCase(extraActions.LoadConnectionList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    ////Fetches loginHistory data to load into the grid in the LoginInformation tab
    .addCase(extraActions.LoadLoginHistory.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(extraActions.LoadLoginHistory.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.fullLoginHistory = action.payload;
      } else {
        state.loginhistory = action.payload;
      }
      state.loading = false;
    })
    .addCase(extraActions.LoadLoginHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    // Validates if the activation email can be resent. Blocks resend if triggered within the last 60 minutes.
    .addCase(
      extraActions.ValidateResendActivationEligibility.pending,
      (state) => {
        state.loading = true;
        state.error = false;
      }
    )
    .addCase(
      extraActions.ValidateResendActivationEligibility.fulfilled,
      (state, action) => {
        state.loading = false;
        state.validateresendEmailVerification = action.payload;
      }
    )
    .addCase(
      extraActions.ValidateResendActivationEligibility.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // Triggers the activation email resend process.
    .addCase(extraActions.ResendActivationEmail.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(extraActions.ResendActivationEmail.fulfilled, (state, action) => {
      state.loading = false;
      state.resendActivationEmail = action.payload;
    })
    .addCase(extraActions.ResendActivationEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    // Manually triggers the account activation process.
    .addCase(extraActions.ActivateAccountManually.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(
      extraActions.ActivateAccountManually.fulfilled,
      (state, action) => {
        state.loading = false;
        state.activateAccountManully = action.payload;
      }
    )
    .addCase(extraActions.ActivateAccountManually.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
